﻿<div class="loading-spinner-overlay"></div>
<figure>
    <svg class="loading-spinner fa fa-spin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <circle class="brand-stroke" cx="50" cy="50" fill="none" stroke-linecap="round" r="30" stroke-width="6" stroke-dasharray="47.12388980384689 47.12388980384689"></circle>
    </svg>
</figure>